import React, { memo } from 'react';
import { useHistory } from 'react-router-dom';
import MypageReturn from '../molecules/MypageReturn';
import { Row, Col } from 'react-bootstrap';
interface Props {
  applied: boolean; // 借入相談登録の状態（true=後、false=前）
  is_change: boolean; // 借入相談変更の状態（true=借入変更）
  is_staff: boolean;
  reception_cd: string;
  reception_id: number;
  status_code: number;
  moveNextStep: VoidFunction;
  movePrevStep: VoidFunction;
  requestModule: () => void | boolean;
}

// KWANKGM02020_借入相談入力確認
const FooterBorrowingConsultationInputConfirmation: React.FC<Props> = ({
  applied,
  is_change,
  is_staff,
  reception_cd,
  reception_id,
  status_code,
  moveNextStep,
  movePrevStep,
  requestModule,
}) => {
  const history = useHistory();

  /**
   * ナビゲーションと画面を完了画面に遷移
   */
  const handleClickNext = async () => {
    const result = await requestModule();

    // 正常終了か判定
    if (result) {
      // 正常終了なら借入相談受付完了画面に遷移
      moveNextStep();
      history.push(`/reception/${reception_cd}/${reception_id}/${status_code}/finish`);
    }
  };

  // 戻るボタンをクリックした時のアクション
  const handleClickPrev = () => {
    movePrevStep();
    history.push(`/reception/${reception_cd}/${reception_id}/${status_code}`);
  };

  const displayButton = () => {
    if (applied) {
      // 借入相談登録後
      if (is_change) {
        // 借入変更の場合
        return jsxElementNextButton();
      } else {
        return jsxElementMypageButton();
      }
    } else {
      // 借入相談登録前
      return jsxElementNextButton();
    }
  };

  // 次へ進むボタンを出力する
  const jsxElementNextButton = () => {
    return (
      <>
        <Row className="mt-5">
          <Col xs={12} sm={12} md={12} lg={12} xl={12}>
            <p>
              連帯債務者等の方(連帯債務・連帯保証で設定している方)にこの借入についてあらかじめ連絡しておいて下さい。
              <br />
              「次へ進む」ボタンを押すと連帯債務者等の方に申込内容確認のためのメールが送信されます。
              <br />
              連帯債務者等がいる場合、連帯債務者等による申込内容の確認と同意が完了すると、JAへの申込処理が完了します。
              <br />
              連帯債務者等の確認状況はマイページから確認可能です。
            </p>
          </Col>
        </Row>
        <Row className="my-5 flex-lg-row flex-md-reverse flex-sm-column-reverse flex-column-reverse">
          <Col xs={12} sm={12} md={12} lg={6} xl={6} className="row-left-button-arrow">
            <div className="text-left">
              <a className="btn btn-xl btn-main-color sp-page-return" onClick={handleClickPrev}>
                戻る
              </a>
            </div>
          </Col>
          <Col xs={12} sm={12} md={12} lg={6} xl={6} className="row-right-button-small">
            <div className="text-right sp-button-center">
              <a
                className="btn btn-xl btn-main-color sp-btn-height ml-auto"
                onClick={handleClickNext}
              >
                次へ進む
              </a>
            </div>
          </Col>
        </Row>
      </>
    );
  };

  // マイページに戻るボタンを出力する
  const jsxElementMypageButton = () => {
    return <MypageReturn is_staff={is_staff} />;
  };

  return displayButton();
};

export default memo(FooterBorrowingConsultationInputConfirmation);
